/* PULLORAX - shop sign-up popup (25 Sept 2026, owner approved).
   Markup, styles and images live in the inert <template id="pxSuPopTpl">
   printed by snippets/pullorax-su-pop.liquid; nothing is injected until the
   popup actually opens. See that snippet for the full rules. */
(function () {
  'use strict';
  var tpl = document.getElementById('pxSuPopTpl');
  if (!tpl || !('content' in tpl) || window.__pxSuPop) return;
  window.__pxSuPop = true;

  var FORM_ID = 'PulloraXPopupSignup';
  var WAIT_MS = 30000;
  var SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;
  var K_T0 = 'px-su-pop-t0', K_SHOWN = 'px-su-pop-shown', K_SNOOZE = 'px-su-pop-snooze', K_DONE = 'px-su-pop-done';

  function sGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function lGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  var search = window.location.search || '';
  var preview = /[?&]px_popup=preview(&|$)/.test(search);
  var posted = /[?&]customer_posted=true/.test(search);
  var sent = sGet('px-su-sent');
  var okMsg = tpl.content.querySelector('[data-pxsp-ok]');
  var errMsg = tpl.content.querySelector('[data-pxsp-err]');
  var lang = tpl.getAttribute('data-lang') || 'en';

  var dlg = null, lastFocus = null, openedThisPage = false;

  /* ---- coming back from our own post: show the result, nothing else ---- */
  if (sent === FORM_ID && (okMsg || errMsg)) {
    if (okMsg) lSet(K_DONE, '1');
    var go = function () { open(true); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
    return;
  }

  if (!preview) {
    if (lGet(K_DONE)) return;
    if (sent) return;                                  /* signed up with another form this visit */
    if (sGet(K_SHOWN)) return;                         /* once per visit */
    var until = parseInt(lGet(K_SNOOZE) || '0', 10);
    if (until && until > Date.now()) return;           /* 7-day snooze */
    if (posted || okMsg || errMsg) return;             /* the page is showing a sign-up result */
  }

  /* ---- triggers: 30 s on the site this visit AND 50% of this page ---- */
  var t0 = parseInt(sGet(K_T0) || '0', 10);
  if (!t0) { t0 = Date.now(); sSet(K_T0, String(t0)); }
  var timeOk = preview, scrollOk = preview;

  function ready() { if (timeOk && scrollOk) attempt(); }

  /* QA fix (functional.md#2): on desktop (>=990px) base.css makes .page-wrapper
     the scrolling box and the window never scrolls, so window metrics gave
     max<=0 and the 50% condition passed on the first screen. The scroller is
     whichever of the two actually overflows; a page that genuinely cannot
     scroll still counts as read. */
  var wrap = document.querySelector('.page-wrapper');
  function scroller() {
    if (wrap && wrap.scrollHeight - wrap.clientHeight > 1) {
      var ov = window.getComputedStyle(wrap).overflowY;
      if (ov === 'auto' || ov === 'scroll') return wrap;
    }
    return null;
  }
  function onScroll() {
    var el = scroller(), max, y;
    if (el) {
      max = el.scrollHeight - el.clientHeight;
      y = el.scrollTop;
    } else {
      var d = document.documentElement;
      max = Math.max(d.scrollHeight, document.body ? document.body.scrollHeight : 0) - window.innerHeight;
      y = window.pageYOffset || d.scrollTop || 0;
    }
    if (max <= 0 || y / max >= 0.5) {
      scrollOk = true;
      window.removeEventListener('scroll', onScroll);
      if (wrap) wrap.removeEventListener('scroll', onScroll);
      ready();
    }
  }

  /* QA 9 Oct 2026 (mobile.md#17): the tile images sit in the inert <template>, so they only started
     downloading when the popup opened and the three tiles showed blank for seconds. Warm the same
     sized files (same srcset/sizes, so the browser picks the same candidate) in the background
     before the popup can open. */
  var warmed = null;
  function warm() {
    if (warmed) return warmed;
    if (!window.Promise) return null;
    var imgs = tpl.content.querySelectorAll('img'), ps = [];
    for (var i = 0; i < imgs.length; i++) {
      var w = new Image();
      if (imgs[i].getAttribute('sizes')) w.sizes = imgs[i].getAttribute('sizes');
      if (imgs[i].getAttribute('srcset')) w.srcset = imgs[i].getAttribute('srcset');
      w.src = imgs[i].getAttribute('src');
      ps.push(w.decode ? w.decode().catch(function () {}) : Promise.resolve());
    }
    warmed = Promise.all(ps);
    return warmed;
  }
  /* the 30 s clock runs per session, so on a later page the popup may be due at once - warm then too */
  window.setTimeout(warm, preview ? 0 : Math.max(0, WAIT_MS - (Date.now() - t0) - 8000));
  if (!preview) {
    window.setTimeout(function () { timeOk = true; ready(); }, Math.max(0, WAIT_MS - (Date.now() - t0)));
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrap) wrap.addEventListener('scroll', onScroll, { passive: true });
    if (document.readyState === 'complete') onScroll(); else window.addEventListener('load', onScroll);
  } else {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  }

  /* ---- the page showing a sign-up success state means: never here ---- */
  function visible(el) { return !!(el && !el.hidden && el.getClientRects().length); }
  function pageShowsSuccess() {
    var els = document.querySelectorAll('[data-px-su-msg], [data-px-release-success], [data-px-toast]');
    for (var i = 0; i < els.length; i++) if (visible(els[i])) return true;
    return false;
  }
  /* ---- something else on screen needs the visitor: wait and retry ---- */
  function busy() {
    var cc = document.getElementById('pxCc');
    if (cc && !cc.hidden) return true;
    /* QA fix (functional.md#9, mobile.md#7): Shopify's own consent banner. */
    var spc = document.getElementById('shopify-pc__banner');
    if (spc && spc.getClientRects().length && window.getComputedStyle(spc).visibility !== 'hidden') return true;
    var prefs = document.getElementById('shopify-pc__prefs');
    if (prefs && prefs.getClientRects().length && window.getComputedStyle(prefs).visibility !== 'hidden') return true;
    if (document.querySelector('dialog[open]')) return true;
    if (document.querySelector('[data-px-notify-modal][aria-hidden="false"]')) return true;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    return false;
  }

  function attempt() {
    if (openedThisPage) return;
    if (!preview) {
      if (sGet('px-su-sent') || sGet(K_SHOWN) || lGet(K_DONE)) return;
      if (pageShowsSuccess()) return;
    }
    if (busy()) { window.setTimeout(attempt, 3000); return; }
    /* open once the tile images are decoded (never wait more than 1.5 s) so they are not blank */
    var go = false, fire = function () { if (go) return; go = true; open(false); };
    if (window.Promise) { warm().then(fire); window.setTimeout(fire, 1500); } else fire();
  }

  /* ---- open / close ---- */
  function focusables() {
    return Array.prototype.filter.call(
      dlg.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.getClientRects().length > 0; }
    );
  }

  function tagsFor(f) {
    var base = (f.getAttribute('data-px-su-base') || 'newsletter').split(',');
    var out = base.concat(['src-' + (f.getAttribute('data-px-su') || 'popup'), 'lang-' + lang]);
    f.querySelectorAll('input[data-px-topic]:checked').forEach(function (c) { out.push(c.getAttribute('data-px-topic')); });
    return out.filter(function (t, i, a) { return t && a.indexOf(t) === i; }).join(',');
  }

  function open(result) {
    if (openedThisPage) return;
    openedThisPage = true;
    document.body.appendChild(tpl.content.cloneNode(true));
    dlg = document.getElementById('pxSuPop');
    if (!dlg) return;
    if (!result && !preview) sSet(K_SHOWN, '1');
    if (result && okMsg) dlg.classList.add('pxsp--done');
    lastFocus = document.activeElement;

    var form = dlg.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      var h = form.querySelector('input[name="contact[tags]"]');
      if (h) h.value = tagsFor(form);
      sSet('px-su-sent', form.id || FORM_ID);
    });

    dlg.querySelectorAll('[data-pxsp-close]').forEach(function (b) {
      b.addEventListener('click', function () { close(); });
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !dlg.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });

    if (typeof dlg.showModal === 'function') {
      try { dlg.showModal(); } catch (err) { dlg.classList.add('pxsp--nomodal'); dlg.setAttribute('open', ''); }
    } else {
      dlg.classList.add('pxsp--nomodal');
      dlg.setAttribute('open', '');
    }

    var target = dlg.querySelector('[data-pxsp-ok], [data-pxsp-err]') || dlg.querySelector('#pxSuPopTitle');
    if (target) { try { target.focus({ preventScroll: true }); } catch (err2) { target.focus(); } }
  }

  function close() {
    if (!dlg) return;
    var done = dlg.classList.contains('pxsp--done') || !!lGet(K_DONE);
    if (!done && !preview) lSet(K_SNOOZE, String(Date.now() + SNOOZE_MS));
    try { if (dlg.open && typeof dlg.close === 'function') dlg.close(); } catch (e) {}
    dlg.removeAttribute('open');
    if (dlg.parentNode) dlg.parentNode.removeChild(dlg);
    dlg = null;
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
    }
  }
})();
